import React, { useState, useMemo } from 'react';

import { GeneralPrint, DataKeyType } from '../GeneralPrint';
import { PostProcessingOptionsProps } from './PostProcessingOptions.types';
import { SelectContainer, Select } from './PostProcessingOptions.styles';

const selectData: { Key: DataKeyType; Value: string }[] = [
  {
    Key: 'drawingPrintSettings',
    Value: 'Drawings'
  },
  {
    Key: 'documentPrintSettings',
    Value: 'Documents'
  }
];

export const PostProcessingOptions: React.FC<PostProcessingOptionsProps> = ({
  printProvider,
  printSettings,
  updateManually
}) => {
  const [activeDataKey, setActiveDataKey] = useState<DataKeyType>(
    'drawingPrintSettings'
  );
  const activeIndex = useMemo(
    () => selectData.findIndex(({ Key }) => Key === activeDataKey),
    [activeDataKey]
  );

  return (
    <>
      <SelectContainer>
        <Select
          dropdownData={selectData}
          withSortButton={false}
          activeIndex={activeIndex}
          onClickSelectItem={(idx) => setActiveDataKey(selectData[idx].Key)}
        />
      </SelectContainer>

      <GeneralPrint
        type="postProcessingOptions"
        printProvider={printProvider}
        printSettings={printSettings}
        dataKey={activeDataKey}
        updateManually={updateManually}
      />
    </>
  );
};
